import React from 'react';
import './settings.css';

export default function SettingsSegment({ options, value, onChange, ariaLabel }) {
  return (
    <div className="settings-segment" role="radiogroup" aria-label={ariaLabel}>
      {options.map((option) => {
        const selected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`settings-segment-item${selected ? ' is-selected' : ''}`}
            onClick={() => onChange?.(option.value)}
          >
            {option.text}
          </button>
        );
      })}
    </div>
  );
}
